import { RequestBodyObjectSchema as OriginalRequestBodyObjectSchema } from '../processed/request-body-object'

/**
 * Request Body Object
 *
 * Describes a single request body.
 *
 * @see https://github.com/OAI/OpenAPI-Specification/blob/main/versions/3.1.1.md#request-body-object
 */
export const RequestBodyObjectSchema = OriginalRequestBodyObjectSchema
